import { apiClient } from "./client";

const GetAll = () => {
  return apiClient
    .get("/Province");
}

const GetByKey = (id) => {
  return apiClient
    .get("/Province/GetByKey", {
      params: {
        'Id': id
      }
    });
}


const SoftDelete = (id) => {
  return apiClient
    .delete("/Province/SoftDelete", {
      params: {
        'Id': id,
        'delete': true
      }
    });
}

const Add = (data) => {
  return apiClient.post('/Province', {
    'name': data.name
  }
  )
}
const Update = (id, data) => {
  return apiClient.put('/Province', {
    'id': id,
    'name': data.name
  }

  )
}
const provinceApi = { Add, Update, GetAll, GetByKey, SoftDelete }
export default provinceApi;